import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITestingPeekOpener = ( createDecorator('testingPeekOpener'));
export { ITestingPeekOpener };
